import { useQuery } from '@tanstack/react-query'
import { Box, formatDate } from '@veracity/vui'

import { apiKeyClient } from '@/api'
import { PageContainer, UserAdministrationPageMenu } from '@/components'
import { useCurrentUser } from '@/hooks'
import { UserAdministrationSection } from '@/interfaces'

import { ProfilePageInfoSection } from './components'

export const ProfilePage = () => {
  const { currentUser, isUser, isAdmin, hasAccessToApi } = useCurrentUser()
  const { data: apiKeyInfo } = useQuery({
    queryKey: apiKeyClient.QUERY_KEY,
    queryFn: apiKeyClient.getApiKeyInfo,
    enabled: isAdmin || (isUser && hasAccessToApi)
  })

  return (
    <PageContainer
      header={<PageContainer.Breadcrumbs items={[{ title: 'Profile' }]} />}
      menuBar={
        <UserAdministrationPageMenu
          activeSection={UserAdministrationSection.USER_PROFILE}
        />
      }>
      <Box column gap={2} bg="white" w="45rem" p={2}>
        <ProfilePageInfoSection
          title="User"
          items={[
            {
              label: 'Name',
              value: currentUser
                ? [currentUser.firstName, currentUser.lastName].join(' ')
                : ''
            },
            { label: 'Email', value: currentUser?.email || '-' },
            { label: 'Role', value: currentUser?.role?.name || '-' }
          ]}
        />

        <ProfilePageInfoSection
          title="Company"
          items={[
            { label: 'Name', value: currentUser?.organization?.name || '' },
            {
              label: 'Pricing plan',
              value: currentUser?.organization?.pricePlanName || ''
            },
            {
              label: 'Subscription Expires',
              value: formatDate(
                currentUser?.organization?.subscriptionExpirationDate,
                'DD MMM YYYY',
                { locales: 'en-US' }
              )
            },
            {
              label: 'Monthly Calculations',
              value: currentUser?.organization
                ? `${currentUser?.organization?.currentCalculationRequestsCount}/${currentUser?.organization?.maxCalculationRequests}`
                : ''
            },
            {
              label: 'Parallel Calculations',
              value: currentUser?.organization
                ? `${currentUser?.organization?.currentParallelCalculationsCount}/${currentUser?.organization?.maxParallelCalculations}`
                : ''
            }
          ]}
        />

        {(isAdmin || (isUser && hasAccessToApi)) && (
          <ProfilePageInfoSection
            title="API"
            items={[
              { label: 'Key', value: apiKeyInfo?.key || '-', isSecret: true },
              { label: 'IsActive', value: apiKeyInfo?.isActive ? 'Yes' : 'No' },
              {
                label: 'Expires',
                value: formatDate(apiKeyInfo?.expirationDate, 'DD MMM YYYY')
              }
            ]}
          />
        )}
      </Box>
    </PageContainer>
  )
}
